/**
 * Opportunities — canonical CRM pipeline (flowstate-automate parity).
 *
 * Renders PipelineDashboard, deal predictor, commission calculator.
 */

import { createFileRoute, redirect } from "@tanstack/react-router";
import { createRouteError } from "../../../components/RouteErrorBoundary";
import { PageSkeleton } from "../../../components/RouteSkeleton";
import OpportunitiesPage from "@/pages/Admin/Opportunities";
import { OnDemandServiceLoader } from "@/components/system/OnDemandServiceLoader";
import type { RouterContextWithSession } from "../../../router";

export const Route = createFileRoute("/_admin/opportunities/")({
  beforeLoad: async ({ context }) => {
    if (typeof window === "undefined") return {};
    const sb = context.supabase;
    if (!sb) return {};
    const {
      data: { session },
    } = await sb.auth.getSession();
    if (!session) {
      throw redirect({ to: "/auth" });
    }
    return { session };
  },
  loader: async ({ context }) => {
    if (typeof window === "undefined") return;
    const { session } = context as RouterContextWithSession;
    if (!session) return;
    await context.queryClient.ensureQueryData({
      queryKey: ["route", "opportunities"],
      queryFn: async () => null,
      staleTime: Infinity,
    });
  },
  pendingComponent: () => <PageSkeleton rows={6} variant="cards" />,
  errorComponent: createRouteError("Opportunities"),
  component: OpportunitiesRoute,
});

function OpportunitiesRoute() {
  return (
    <OnDemandServiceLoader serviceNames={["client", "opportunity"]}>
      <div className="flex min-h-0 flex-1 flex-col">
        <OpportunitiesPage />
      </div>
    </OnDemandServiceLoader>
  );
}
